/**
 * Created by fjywan on 2018/3/19.
 */
export default class Api {
  constructor (request, urls={}) {
    this.list = (params = {}) => {
      params.count = params.count || 10
      return request.get(urls.list, {params})
    }
    this.one = (id) => {
      const query = {
        params: {}
      }
      if (id && typeof id === 'object') {
        query.params = id
      } else {
        query.params.id = id
      }
      return request.get(urls.one, query)
    }
    this.add = (data) => {
      return request.post(urls.add, data)
    }
    this.update = (data) => {
      return request.post(urls.update, data)
    }
    this.delete = (data) => {
      return request.post(urls.delete, data)
    }
    this.export = (params = {}) => {
      return request.post(urls.export, params)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/helper/api/index.js